import React from 'react';
import { iconClose, iconHunburger} from '~utils/svgIcons';
import Nav from '../nav';
import './style.scss';

function MobileNavigation() {
    const [isMobileMenuOpened, setMobilePopupVisiability] = React.useState(false);

    const onOpenMobileMenu = React.useCallback(() => {
        setMobilePopupVisiability(true);
        document.body.style.overflow = 'hidden';
        // document.body.style.height = '100vh';
        // document.body.style.position = 'fixed';
        document.body.style.top = '0';
        document.body.style.left = '0';
        document.body.style.right = '0';
        document.body.style.bottom = '0';
    }, [setMobilePopupVisiability]);

    const onCloseMobileMenu = React.useCallback(() => {
        setMobilePopupVisiability(false);
        document.body.style.overflow = 'auto';
        // document.body.style.height = 'auto';
        document.body.style.position = 'static';
    }, [setMobilePopupVisiability]);

    return (
        <div className={`mob-navigation${isMobileMenuOpened ? ' opened' : ''}`}>
            <div className="mob-navigation__mobile-top-wrap">
                <div className="mob-navigation__mobile-inner">
                    <div
                        className="mob-navigation__mobile-menu-btn"
                        onClick={isMobileMenuOpened ? onCloseMobileMenu : onOpenMobileMenu}
                    >
                        {isMobileMenuOpened ? iconClose : iconHunburger}
                    </div>
                </div>
            </div>
            <div className="mob-navigation__wrap">
                <Nav onClick={onCloseMobileMenu} />
            </div>
        </div>
    );
}

export default MobileNavigation;
export { MobileNavigation };



// WEBPACK FOOTER //
// ./src/components/navigation/mobile/index.js